<template>
    <div class="card mb-3">
        <div class="card-body">
            <div class="">
                <div class="row g-3">
                    <div class="col-6">
                        <span class="time">
                            {{ transaction.paymentDate }}
                        </span>
                    </div>
                    <div class="col-6 text-end">
                        <span class="badge" :class="{ 'bg-danger': transaction.status == 0, 'bg-success': transaction.status != 0 }">{{
                                transaction.status == 0 ? 'تراکنش ناموفق' : 'تراکنش موفق' }}
                        </span>
                    </div>
                    <div class="col-8">
                        <p v-if="transaction.status != 0" class="ref-number">شماره ارجاع:
                            <span v-if="transaction.RefId">
                                {{ transaction.RefId }}
                            </span>
                            <span v-else>
                                {{ transaction.payment_type ? "کارت به کارت" : "آنلاین" }}
                            </span>
                        </p>
                    </div>
                    <div class="col-4 text-end">{{ formatPrice(transaction.amount) }} تومان</div>
                    <div v-if="transaction.status == 0" class="col-12">
                        <div class="card">
                            <div class="card-body bg-gray p-2">
                                <p class="card-text text-unSuccess">
                                    چنانچه مبلغ از حسابتان کم شده ولی صورت حساب پرداخت نشده است. مبلغ کم شده
                                    تا 48 ساعت آینده به حساب بانکی تان برمیگردد.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['transaction'],
    methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(",", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
}
</script>
<style scoped>
.time {
    font-size: 12px;
    color: #808080;
}

.ref-number {
    font-size: 11px;
    font-weight: 600;
}

.text-unSuccess {
    font-size: 11px;
    font-weight: 500;
}

.bg-gray {
    background-color: #f9f9f9;
}
</style>